import { FC } from 'react'
import { authSlice } from '@wellesley/auth'
import { useSelector } from 'react-redux'
import { instanceInfoSlice } from '@wellesley/instanceinfo'
import { AboutServerSection } from '@wellesley/server-info'
import { platformSettingsSlice } from '@wellesley/settings/slices/platformSettingsSlice'
import { useGetApiV1DomainBlockQuery } from '@wellesley/openapi'
import {
  brandingSettingsKeys,
  useFetchPlatformSettings,
} from '@wellesley/settings'

import { BrandLayout } from '../layouts/BrandLayout'
import { ToolbarLayout } from '../layouts/ToolbarLayout'
import { AboutHostServerSection } from '../../features/server-info/AboutHostServerSection'

export const AboutServerPage: FC = () => {
  useFetchPlatformSettings(brandingSettingsKeys)
  const isAuthenticated = useSelector(authSlice.selectors.selectIsAuthenticated)
  const instanceInfo = useSelector(
    instanceInfoSlice.selectors.selectInstanceInfo,
  )

  const { selectAccess, selectBranding, selectContacts, selectDomainBlocks } =
    platformSettingsSlice.selectors

  const { visibility } = useSelector(selectAccess) || {}

  const isPrivate = visibility === 'PRIVATE'

  const brandingSettings = useSelector(selectBranding)

  const contactsSettings = useSelector(selectContacts)

  const domainBlocksSettings = useSelector(selectDomainBlocks)

  const serverRules = instanceInfo?.rules || []
  const serverName = instanceInfo?.uri
  const serverVersion = instanceInfo?.version
  const serverImageThumbnail = brandingSettings?.image || ''

  const domainBlocksAccess = domainBlocksSettings?.domainBlocksAccess
  const domainBlocksReasonAccess =
    domainBlocksSettings?.domainBlocksReasonAccess

  const stats = useSelector(instanceInfoSlice.selectors.selectInstanceStats)

  const { data: domainBlocks, isLoading: isDomainBlocksLoading } =
    useGetApiV1DomainBlockQuery({})
  const hasBlockedDomains = !!domainBlocks && domainBlocks.length > 0

  const showBlockedDomainsTab =
    hasBlockedDomains &&
    ((domainBlocksAccess == 'USER' && isAuthenticated) ||
      domainBlocksAccess == 'ALL')
  const showBlockedDomainsReason =
    (domainBlocksReasonAccess == 'USER' && isAuthenticated) ||
    domainBlocksReasonAccess == 'ALL'

  const serverInfoData = {
    name: brandingSettings?.displayName || serverName || '',
    image: serverImageThumbnail || '',
    version: serverVersion || '',
    accessVisibility: visibility || 'PUBLIC',
  }
  const contacts = {
    email: contactsSettings?.email || '',
    username: contactsSettings?.username || '',
  }
  const description = brandingSettings?.description || ''

  if (isPrivate && !isAuthenticated) {
    return (
      <BrandLayout>
        <AboutHostServerSection
          isLoading={isDomainBlocksLoading}
          showBlockedDomainsTab={showBlockedDomainsTab}
          showBlockedDomainsReason={showBlockedDomainsReason}
          description={description}
          serverRules={serverRules}
          contacts={contacts}
          stats={stats}
        />
      </BrandLayout>
    )
  }
  return (
    <ToolbarLayout>
      <AboutServerSection
        className="md:min-w-[760px]"
        isLoading={isDomainBlocksLoading}
        showBlockedDomainsTab={showBlockedDomainsTab}
        showBlockedDomainsReason={showBlockedDomainsReason}
        description={description}
        serverInfoData={serverInfoData}
        serverRules={serverRules}
        contacts={contacts}
        stats={stats}
      />
    </ToolbarLayout>
  )
}
